/// <amd-module name="Test/TestCaseResults/Constants" />
export const ZeroDataImagePath = "ms.vss-test-web/testplan-hub-refresh-assets/zero-data-execute-tab.png";
export const NoTestCaseImagePath = "ms.vss-test-web/testplan-hub-refresh-assets/zero-data-no-plan-image.png";
export const TestRunsPageRouteId = "ms.vss-test-web.test-runs-route";
export const TestHubRefreshRouteId = "ms.vss-test-web.testplans-hub-refresh-route";
export const ToastNotificationDurationInMs = 5000;

export const testRunsPageQueryParams = "?_a=resultSummary&runId={0}&resultId={1}";
export const TestHubRefreshQueryParams = "/execute?planId={0}";
export const QueryParamContextPointId = "contextPointId";

export const OutcomeColumn = "OutcomeColumn";
export const TimestampColumn = "TimestampColumn";
export const ConfigurationColumn = "ConfigurationColumn";
export const RunbyColumn = "RunbyColumn";
export const TesterColumn = "TesterColumn";
export const TestPlanColumn = "TestPlanColumn";
export const TestSuiteColumn = "TestSuiteColumn";

// filter
export const OutcomeFilterKey="outcomeFilter";
export const ConfigurationFilterKey="configurationFilter";
export const TesterFilterKey="testerFilter";
export const PlanFilterKey="planFilter";
export const SuiteFilterKey="suiteFilter";

// Telemetry Constants
export const FILTER_VALUES_CHANGED = "FILTER_VALUES_CHANGED";
export const FILTER_TOGGLED = "FILTER_TOGGLED";
export const OPEN_RUNS_HUB = "OPEN_RUNS_HUB";
export const LOAD_INITIAL_RESULTS = "LOAD_INITIAL_RESULTS";
export const TESTCASE_RESULTS_FEATURE_AREA_NAME = "TestCaseResults";
export const TEST_HUB_FEATURE_AREA_NAME = "TestManagement";

